type RefundStatusState = {
    label: string
    color: string
}

export const RefundStatusConfig: Record<number, RefundStatusState> = {
    1: { label: 'Возврат создан', color: 'bg-yellow-100 text-yellow-800' },
    2: { label: 'Возврат проведён', color: 'bg-green-100 text-green-800' },
    20: { label: 'Ошибка возврата', color: 'bg-red-100 text-red-800' },
    22: { label: 'Ошибка возврата', color: 'bg-red-100 text-red-800' },
    30: { label: 'Возврат завершён', color: 'bg-green-100 text-green-800' },
    40: { label: 'Возврат не требуется', color: 'bg-gray-100 text-gray-800' },
}

const UnknownRefundStatusConfig: RefundStatusState = {
    label: 'Возврат в обработке',
    color: 'bg-yellow-100 text-yellow-800',
}

export const getRefundStatusLabel = (status: number | null | undefined): string | null => {
    if (status == null) {
        return null
    }

    return (RefundStatusConfig[status] ?? UnknownRefundStatusConfig).label
}

export const getRefundStatusColor = (status: number | null | undefined): string | null => {
    if (status == null) {
        return null
    }

    return (RefundStatusConfig[status] ?? UnknownRefundStatusConfig).color
}
